import { render, staticRenderFns } from "./Regulamento.vue?vue&type=template&id=7228cb8e&"
import script from "./Regulamento.vue?vue&type=script&lang=js&"
export * from "./Regulamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports